import numberFormat from "@/helpers/numberFormat";
import { Inertia } from "@inertiajs/inertia";
import { Link } from "@inertiajs/inertia-react";
import Swal from "sweetalert2";
import Button from "../Button";

const ProductItem = ({ id, name, price, deleted_at }) => {

    
    const openSwalDelete = () => {
        const swalWithCustomButtons = Swal.mixin({
            buttonsStyling: false,
            customClass: {
                cancelButton: 'mx-1 inline-flex items-center px-4 py-2 bg-gray-400 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest active:bg-gray-900 transition ease-in-out duration-150',
                confirmButton: 'mx-1 inline-flex items-center px-4 py-2 bg-red-600 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest active:bg-gray-900 transition ease-in-out duration-150'
            },
            reverseButtons: true,
            showCancelButton: true,
        });

        swalWithCustomButtons.fire({
            icon: 'warning',
            title: '¿Estás seguro de que quieres eliminar este producto?',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Estoy seguro',
        }).then(({ isConfirmed }) => {
            if (isConfirmed) {
                Inertia.delete(route('products.delete', id));
            }
        });
    }

    return (
        <div className="flex justify-between px-4 w-full bg-white rounded-xl py-4 mb-4">
            <h3>
                {name}
            </h3>
            <h4>
                ${numberFormat(price, 0, '', '.')}
            </h4>
            <div className="flex items-center gap-2">
                {deleted_at ? (
                    <p>Eliminado {deleted_at}</p>
                ) : (
                    <>
                        <Link href={route('products.edit', id)}>
                            <Button>Editar</Button>
                        </Link>
                        <Button className="bg-red-600" onClick={openSwalDelete}>Eliminar</Button>
                    </>
                )}
            </div>
        </div>
    )
}

export default ProductItem;